module.exports = __webpack_public_path__ + "static/media/jaune.14640948.png";